import apiService from "../common/commonApi";

export const department = {};

department.list = async (param) => {    
    return apiService.Get('department-list', param);
}

department.add = async (param) => {    
    return apiService.Post('department-create', param);
}

department.delete = async (param) => {    
    return apiService.Post('department-delete', param);
}

department.update = async (param) => {    
    return apiService.Post('department-update', param);
}